module.exports = __webpack_public_path__ + "static/media/Discover.44cb8b55.svg";